<template>
  <router-view></router-view>
</template>

<script>
export default {
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.alert{
  width: 100%;
}
.back-wrapper{
  position: absolute;
  z-index: 2;
  top: 1rem;
  width: 50%;
}

.back-item,
.back-item:hover,
.back-item:focus{
  color: #fff;
  display: flex;
  font-size: 20px;
  text-transform: uppercase;
}
.back-item img{
  margin-right: 15px;
}
.multiselect__select:before{
  display: none !important;
  margin-top: 4px;
  border-color: #F0F2FF transparent transparent !important;
}
.statusOrders .multiselect__select:before{
  color: transparent !important;
  margin-top: 4px;
  border-color: #F0F2FF transparent transparent !important;
}
.card .table td, .card .table th{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.form-control {
  color: #000;
}
.multiselect__placeholder,
.form-control::placeholder {
  color: #000;
}
.custom-control-label::after,
.custom-control-label::before{
    left: 0;
}
.custom-control.custom-checkbox{
  padding-left: 0;
  width: 20px;
  height: 20px;
}
@media (max-width: 1600px) {
  .back-item img{
    width: 25px;
  }
  .back-item,
  .back-item:hover,
  .back-item:focus{
    font-size: 16px;
  }
}
</style>

